export default
{
  wizardSteps: [
    {
      index: 0,
      text: 'Setup',
      title: 'Basic Info',
      subtitle: 'Basic Info',
      dataTest: 'basic-info-step',
      href: '#details',
      disabled: false,
    },
    {
      index: 1,
      text: 'Content',
      title: 'Add Content',
      subtitle: 'Content',
      dataTest: 'content-step',
      href: '#content',
      disabled: true,
    },
    {
      index: 2,
      text: 'Creative',
      title: 'Build your creative',
      subtitle: 'Creative',
      dataTest: 'creative-step',
      href: '#creative',
      disabled: true,
    },
    {
      index: 3,
      text: 'Summary',
      title: 'Summary & Billing',
      subtitle: 'Summary',
      dataTest: 'summary-step',
      href: '#summary',
      disabled: true,
    },
    {
      index: 4,
      text: 'Invoicing',
      title: 'Summary & Billing',
      subtitle: 'Billing',
      dataTest: 'billing-step',
      href: '#invoicing',
      disabled: true,
    },
  ],
};
